export enum FormRenderGroupTypes {
	basic = "Podstawowe",
	additionalInformation = "Dodatkowe informacje",
	seo = "SEO",
	configuration = "Konfiguracja",
	address = "Adres",
	automatic = "Automatyczne ustwienia terminów",
	values = "Wartości",
	offerOptions = "Opcje oferty",
	participants = "Uczestnicy",
	applicant = "Dane zgłaszającego",
}
